import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Typography,
  Autocomplete,
  Avatar,
} from "@mui/material";
import { UseGeneralPages } from "../../UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../../components/ProgressCom";
import Detail from "../../../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function EditPageFAQ() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { UpdatePageFAQ, validateFAQ } = UseGeneralPages();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [state, setState] = useState({
    id: "",
    rowNO: "",
    answer: "",
    question: "",
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state.model) {
      setState({
        id: location.state.model.id,
        rowNO: location.state.model.rowNO,
        answer: location.state.model.answer,
        question: location.state.model.question,
        generalID: location.state.id,
      });
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    answer: false,
    question: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/generalpages" },
          {
            name: "ویرایش صفحه",
            url: "/generalpages/pageDetail",
            targetID: location.state.id,
            scrollTo: location.state.scrollTo,
          },
          {
            name: "ویرایش پرسش",
            url: "/generalpages/pageDetail/editPageFAQ",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <Typography sx={{ my: 1 }} variant="body1" color="secondary">
              پرسش :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                data={state.question ? state.question : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (state.id) {
                    setState({ ...state, question: data });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <Typography sx={{ my: 1 }} variant="body1" color="secondary">
              پاسخ :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                data={state.answer ? state.answer : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (state.id) {
                    setState({ ...state, answer: data });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validateFAQ(state, setErrorState) == 200) {
                  setProgress(true);
                  UpdatePageFAQ(state, () => {
                    navigate("/generalpages/pageDetail", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/generalpages/pageDetail", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
